export default [
    {
        path: '/login',
        layout: false,
        component: './login/index_new',
    },
    {
        path: '/account',
        name: '帳號管理',
        icon: 'user',
        access: 'canAccountPage',
        routes: [
            {
                name: '內容管理後台',
                icon: 'dashboard',
                path: '/account/content_manager',
                component: './account/content_manager/index',
                access: 'canAccountPage',
            },
            {
                name: '評選後台',
                icon: 'team',
                path: '/account/judge_manager',
                component: './account/judge_manager/index',
                access: 'canAccountPage',
            },
            {
                path: '/account/judge_manager/:admin_id',
                component: '@/pages/account/judge_manager/index.tsx',
            },
        ],
    },
    {
        path: '/annual_award',
        name: '獎項管理',
        icon: 'trophy',
        component: './annual_award/index',
        access: 'canAwardPage',
    },
    {
        path: '/annual_award_review',
        name: '評審管理',
        icon: 'team',
        access: 'canJudgePage',
        routes: [
            {
                name: '評審名單',
                icon: 'team',
                path: '/annual_award_review/reviewer',
                component: './annual_award_reviewers/index',
                access: 'canJudgePage',
            },
            // {
            //     name: '年度評選紀錄',
            //     icon: 'file-text',
            //     path: '/annual_award_review/review_record',
            //     component: './annual_award_review_record/index',
            //     access: 'canJudgePage',
            // },
        ],
    },
    {
        path: '/website_content',
        name: '網站內容',
        icon: 'global',
        access: 'canContentPage',
        routes: [
            {
                name: '活動簡章管理',
                icon: 'file-text',
                path: '/website_content/brief',
                component: './brief/index',
                access: 'canContentPage',
            },
            {
                name: '橫幅管理',
                icon: 'picture',
                path: '/website_content/banner',
                component: './banner/index',
                access: 'canContentPage',
            },
            {
                name: '最新消息',
                icon: 'notification',
                path: '/website_content/news',
                component: './news/index',
                access: 'canContentPage',
            },
            {
                name: '活動時間線',
                icon: 'clock-circle',
                path: '/website_content/timeline',
                component: './timeline/index',
                access: 'canContentPage',
            },
            {
                name: '評委專區',
                icon: 'team',
                path: '/website_content/reviewer_area',
                component: './reviewer_area/index',
                access: 'canContentPage',
            },
            {
                name: 'Logo資訊',
                icon: 'appstore',
                path: '/website_content/logo',
                component: './logo/index',
                access: 'canContentPage',
            },
            // {
            //     name: '展覽頁面',
            //     icon: 'picture',
            //     path: '/website_content/exhibition',
            //     component: './exhibition/index',
            //     access: 'canContentPage',
            // },
        ],
    },
    // {
    //     path: '/member',
    //     name: '會員管理',
    //     icon: 'team',
    //     component: './member/index',
    //     access: 'canAccountPage',
    // },
    // {
    //     path: '/project',
    //     name: '作品管理',
    //     icon: 'project',
    //     component: './project/index',
    //     access: 'canAccountPage',
    // },
    // {
    //     path: '/reward',
    //     name: '晉級/得獎管理',
    //     icon: 'trophy',
    //     access: 'canJudgePage',
    //     routes: [
    //         {
    //             name: '一般獎項',
    //             icon: 'trophy',
    //             path: '/reward/normal',
    //             component: './reward/normal/index',
    //             access: 'canJudgePage',
    //         },
    //         {
    //             name: '人氣獎',
    //             icon: 'fire',
    //             path: '/reward/popular',
    //             component: './reward/popular/index',
    //             access: 'canJudgePage',
    //         },
    //     ],
    // },
    {
        path: '/',
        component: './blank',
    },
    {
        path: '403',
        component: './403',
    },
    {
        component: '404',
        path: '/*',
    },
];
